export const companySettingInitialState = {
	settings: null,
	error: null,
	errorShow: false,
	loading: false,
	companies: null,
};
